import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import SideBar from "../../components/SideBar";
import { Components } from "../../assets/Dimensions";
import SwitchComponent from "../../components/SwitchComponent";
import { ToastContainer, toast } from "react-toastify";
import "../questionVideoSolution/style.css";
import { getCourses, nestedTitles } from "../../api/QuestionSubCourseSelection/courses";
import Toggle from "../questionVideoSolution/components/toggle/toggle";
import { encryption, base64Encode } from "../../helpers/encryptionHelper";
import CourseBG from "../../assets/images/bg-lesson.jpeg";
import ExamCategoryType from "../../enums/ExamCategoryType";
import ExamType from "../../enums/ExamType";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import { setCookie } from "../../helpers/cookie";
import QuestionPage from "../questionSubTopicSelection/QuestionPage";
import { useHistory } from 'react-router-dom';
import Loader from "@material-ui/core/CircularProgress"
import {getAllClassTypeTopics} from '../../api/Book'
import { GetAllSegments, GetSegmentCourses, GetSegmentTopics } from "../../api/CMS";
import ContentType from "../../enums/ContentType";

const TaskStatusLabelsTr = {
  0: "Yok",
  1: "Yapılacak",
  2: "Devam Ediyor",
  3: "İnceleme Bekliyor",
  4: "İncelemede",
  5: "Tamamlandı",

};

const TaskStatusColors = {
  1: "#3b82f6", // Todo - blue-500
  2: "#facc15", // InProgress - yellow-400
  3: "#22c55e", // PendingReview - green-500
  4: "#a855f7", // InReview - purple-500
  5: "#14b8a6", // Done - teal-500

};



const CoursePage = () => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 700px)" });
  const user = JSON.parse(localStorage.getItem("user"));
  const userAdminToken = sessionStorage.getItem("jwtP");

  const [nav, setNav] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedExamCategory, setSelectedExamCategory] = useState(null);
  const [coursesData, setCoursesData] = useState([]);
  const [allCourseData, setAllCourseData] = useState(null);
  const [examTypeId, setExamTypeId] = useState(1);
  const [loader, setLoader] = useState(false);
  const [segmentTopics, setSegmentTopics] = useState(null);
  const [classTypes, setClassTypes] = useState([]); // for modal
  const [openCourseId, setOpenCourseId] = useState(null); // which accordion is open
  const [selectedClassTypeId, setSelectedClassTypeId] = useState(null); // which accordion is open
const [topicsByCourse, setTopicsByCourse] = useState({}); // store fetched topics for each course


  const history = useHistory();

  const style = {
    
    container: {
      //state e bool değer ekle menü butonuna basıldığında css
      //içinde container a margin eklesin hemde navı açsın

      //marginLeft: isTabletOrMobile ? 0 : Components.SideBarWidth + 15,
      paddingLeft: isTabletOrMobile ? 15 : Components.SideBarWidth + 15,
      paddingTop: 20,
      paddingRight: 15,
      marginBottom: 20,
    },
    editIcon: {
      width: Components.Image.Big.Width,
      height: Components.Image.Big.Height,
    },
    iconButton: {
      marginLeft: 10,
      padding: 0,
    },
  };

  

  


  const getExamTypeName = (value) => {
    for (const key in ExamType) {
      if (ExamType[key] === value) {
        return key;
      }
    }
    return null; // Return null if the value is not found
  };

  const groupByTitle = (items) => {
    return items.reduce((acc, curr) => {
      if (!acc[curr.Title]) acc[curr.Title] = [];
      acc[curr.Title].push(curr);
      return acc;
    }, {});
  };
  

// 🧠 STEP 1: Fetch + Structure ClassType → Courses
const getAllData = async () => {
  const getSelctedClassTypeFromLocal = JSON.parse(localStorage.getItem("selectedClassTypeId"))
  try {
    setLoader(true);
    const res = await GetAllSegments(user.Token);

    if (res.data.ResponseStatus === 1) {
      const response = res.data.ResponseData;
      localStorage.setItem("MaarifModelData",JSON.stringify(response))
      // Log once to inspect the shape

      // Store full data for filtering later
      setAllCourseData(response);

      // Extract unique ClassTypeIds for modal
      const classTypeIds = response.map(item => ({
        ClassTypeId: item.ClassTypeId,
        ClassTypeName: item.ClassTypeName || "Bilinmeyen Tür"
      }));

      setClassTypes(response); // we’ll add this new state below
if(getSelctedClassTypeFromLocal){
  setSelectedClassTypeId(getSelctedClassTypeFromLocal)
  selectExamCategory(getSelctedClassTypeFromLocal);
}else{

  setIsOpen(true);
}
    } else {
      toast.error("Veri alınamadı. Lütfen tekrar deneyiniz.");
      history.push('./userprofile')
    }
  } catch (error) {
    console.error("Error fetching class type topics:", error);
    toast.error("Bir hata oluştu, lütfen yetkililerle iletişime geçiniz.");
  } finally {
    setLoader(false);
  }
};

// const getSelectedSegmentCourseTopis = async (id) => {
//   try {
//     setLoader(true);
//     const res = await GetSegmentTopics(id,user.Token);

//     if (res.data.ResponseStatus === 1) {
//       const response = res.data.ResponseData;
//       // localStorage.setItem("MaarifModelData",JSON.stringify(response))
//       // Log once to inspect the shape
//       // console.log("Class Type Topics API:", response);

//       // Store full data for filtering later
//       setSegmentTopics(response);

//       // Extract unique ClassTypeIds for modal
//       // const classTypeIds = response.map(item => ({
//       //   ClassTypeId: item.ClassTypeId,
//       //   ClassTypeName: item.ClassTypeName || "Bilinmeyen Tür"
//       // }));

//       // setClassTypes(response); // we’ll add this new state below
//       // setIsOpen(true);
//     } else {
//       toast.error("Veri alınamadı. Lütfen tekrar deneyiniz.");
//       history.push('./userprofile')
//     }
//   } catch (error) {
//     console.error("Error fetching class type topics:", error);
//     toast.error("Bir hata oluştu, lütfen yetkililerle iletişime geçiniz.");
//   } finally {
//     setLoader(false);
//   }
// };


const getSelectedSegmentCourseTopis = async (courseId) => {
  try {
    setLoader(true);
    const res = await GetSegmentTopics(courseId, user.Token);

    if (res.data.ResponseStatus === 1) {
      const grouped = groupByTitle(res.data.ResponseData);
      setTopicsByCourse((prev) => ({
        ...prev,
        [courseId]: grouped,
      }));
    } else {
      toast.error("Veri alınamadı. Lütfen tekrar deneyiniz.");
    }
  } catch (error) {
    console.error("Error fetching segment topics:", error);
    toast.error("Bir hata oluştu, lütfen yetkililerle iletişime geçiniz.");
  } finally {
    setLoader(false);
  }
};


  


  useEffect(()=>{
    getAllData()
  },[])

  // useEffect(() => {
  //   getCoursesData();
  // }, [selectedExamCategory]);
  const selectExamCategory =async (id) => {
     setSelectedExamCategory(id);
    // localStorage.setItem("SelectedExamCategory", id);
  
      try {
        setLoader(true);
        const res = await GetSegmentCourses(id,user.Token);
    
        if (res.data.ResponseStatus === 1) {
          const response = res.data.ResponseData;
          // Log once to inspect the shape
    
          // Store full data for filtering later
          // setAllCourseData(response);
          setCoursesData(response);
    
          // Extract unique ClassTypeIds for modal
          // const classTypeIds = response.map(item => ({
          //   ClassTypeId: item.ClassTypeId,
          //   ClassTypeName: item.ClassTypeName || "Bilinmeyen Tür"
          // }));
    
          // setClassTypes(classTypeIds); // we’ll add this new state below
          // setIsOpen(true);
        } else {
          toast.error("Veri alınamadı. Lütfen tekrar deneyiniz.");
          history.push('./userprofile')
        }
      } catch (error) {
        console.error("Error fetching class type topics:", error);
        toast.error("Bir hata oluştu, lütfen yetkililerle iletişime geçiniz.");
      } finally {
        setLoader(false);
      }

  
    // Find the selected ClassType from full API data
    // const selectedClass = allCourseData.find(item => item.ClassTypeId === id);
  
    // if (selectedClass && selectedClass.Courses) {
    //   var enrichedCourses = selectedClass.Courses.map(function (course) {
    //     return Object.assign({}, course, { ExamType: selectedClass.ExamType });
    //   });
  
    //   setCoursesData(enrichedCourses);
    // } else {
    //   toast.error("Bu sınıf türü için kurs bulunamadı.");
    // }
  
    setIsOpen(false);
  };


  

  return (
    <>
      {isTabletOrMobile ? (
        <div>
          <span
            style={{ position: "absolute", top: 10, right: 10 }}
            onClick={() => setNav(!nav)}
          >
            menu
          </span>
          {nav && <SideBar />}
        </div>
      ) : (
        <SideBar />
      )}

      {loader&&<div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Loader size={100} />
          </div>}

      <div style={style.container}> 
      {isOpen && (
  <div className="modal">
    <div className="modal-content">
      <div style={{ textAlign: "center" }}>
        <h2>Lütfen Sınav Seçimi Yapınız</h2>
        <div
          style={{ display: "flex", justifyContent: "space-around", flexWrap: "wrap" }}
        >
          {classTypes.map((classType) => (
            <button
              key={classType.ClassTypeId}
              style={{ padding: 10, width: "30%", marginBottom: 10 }}
              onClick={() => {
                setSelectedClassTypeId(classType.Id)
                selectExamCategory(classType.Id);
                localStorage.setItem("selectedClassTypeId",classType.Id)
              }}
            >
             {classType.ClassTypeName}
{classType.ExamTypeId > 0 && ` - ${classType.ExamTypeName}`}

            </button>
          ))}
        </div>
      </div>
    </div>
  </div>
)}

        <div style={{fontWeight:"bold",fontSize:"20px"}}>
          Konu ve Kazanım Onaylama Paneli
        </div>
        {selectedExamCategory && (
  <div
    style={{
      display: "flex",
      flexDirection: "row-reverse",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 10,
      margin: 10,
    }}
  >
    <div
      style={{
        borderWidth: 2,
        borderColor: "black",
        borderRadius: 8,
        padding: 10,
        borderStyle: "solid",
        cursor: "pointer",
        alignItems: "center",
        display: "flex",
      }}
      onClick={function () {
        setIsOpen(true);
      }}
    >
      {(() => {
  const found = classTypes.find((type) => type.Id === selectedExamCategory);
  if (!found) return "Sınıf Türü Seçili Değil";
  return `${found.ClassTypeName}${found.ExamTypeId > 0 ? ` - ${found.ExamTypeName}` : ""}`;
})()}


      <IconButton style={style.iconButton}>
        <EditIcon style={style.editIcon} />
      </IconButton>
    </div>
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "12px",
        padding: "10px 0",
        alignItems: "center",
      }}
    >
      {Object.entries(TaskStatusLabelsTr)
        .filter(([key]) => key !== "0") // skip "Yok"
        .map(([key, label]) => (
          <div
            key={key}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: 14,
            }}
          >
            <div
              style={{
                width: 16,
                height: 16,
                borderRadius: 4,
                backgroundColor: TaskStatusColors[key],
              }}
            ></div>
            <span >{label}</span>
          </div>
        ))}
    </div>
  </div>
)}


{coursesData.map((course) => (
  <div key={course.Id}>
    {/* Course Header */}




    {/* <div
      style={{
        color: "#FFFFFF",
        backgroundImage: `url(${CourseBG})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        padding: 30,
        display: "flex",
        justifyContent: "space-between",
        borderRadius: 8,
        cursor: "pointer",
        marginBottom: 8,
        flexDirection:"column"
      }}
      // onClick={() => {
      //   if (openCourseId === course.Id) {
      //     setOpenCourseId(null);
      //   } else {
      //     setOpenCourseId(course.Id);
      //     if (!topicsByCourse[course.Id]) {
      //       getSelectedSegmentCourseTopis(course.Id);
      //     }
      //   }
      // }}
    >
      <div>
      <div>{course.Name}</div>
      <div>{openCourseId === course.Id ? "▲" : "▼"}</div>
        </div>
<div>
<div  onClick={() => {
        if (openCourseId === course.Id) {
          setOpenCourseId(null);
        } else {
          setOpenCourseId(course.Id);
          if (!topicsByCourse[course.Id]) {
            getSelectedSegmentCourseTopis(course.Id);
          }
        }
      }}>Konu Seç</div>
<div 

onClick={() =>
  // console.log("states-history", {
    // courseId: course.Id,
    // courseName: course.Name,
    // topicName: topicTitle,
    // SegmentTopicId: sub.Id,
    // subTopicName: sub.Name,
    // // examType: course.ExamType,
    // classTypeId: selectedExamCategory,
  // },)
  history.push({
    pathname:
      "/NewTopicAndAchSelectionQuestionPage",
    state: {
      courseId: course.Id,
      courseName: course.Name,
      // topicName: topicTitle,
      // SegmentTopicId: sub.Id,
      // subTopicName: sub.Name,
      // examType: course.ExamType,
      classTypeId: selectedExamCategory,
      contentType:ContentType.Courses,
      segmentId:selectedClassTypeId,
      

    },
  })
}
>Başla</div>

</div>
    </div> */}






<div
  key={course.Id}
  style={{
    // color: "black",
    // backgroundImage: `url(${CourseBG})`,
    // backgroundRepeat: "no-repeat",
    // backgroundPosition: "center center",
    // backgroundSize: "cover",
    padding: 24,
    borderRadius: 8,
    cursor: "pointer",
    marginBottom: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    transition: "transform 0.15s ease-in-out",
  }}
>
  {/* --- Top Row: Course Name + Stats --- */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 10,
    }}
  >
    <div style={{ fontSize: 18, fontWeight: "bold" }}>{course.Name}</div>

    {/* Stats Container */}
   {course.TotalCount>0&& <div
      style={{
        backgroundColor: "#fff",
        borderRadius: 6,
        padding: "6px 12px",
        display: "flex",
        gap: 8,
        color: "#111",
        fontWeight: 600,
        position: "relative",
        cursor: "default",
      }}
      className="stats-container"
    >
      
      {Array.isArray(course.Counts) && course.Counts.length > 0 ?course.Counts.map((item) => (
        <span
          key={item.TaskStatus}
          style={{
            color: TaskStatusColors[item.TaskStatus],
          }}
        >
          {item.Count}
        </span>
      )):null}

      {/* Tooltip */}
     <div
        style={{
          visibility: "hidden",
          opacity: 0,
          position: "absolute",
          top: "120%",
          right: 0,
          backgroundColor: "#fff",
          color: "#111",
          padding: "10px 14px",
          borderRadius: 8,
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          fontSize: 14,
          transition: "opacity 0.2s ease, visibility 0.2s ease",
          zIndex: 10,
          minWidth: 180,
        }}
        className="stats-tooltip"
      >
        <ul style={{ listStyleType: "disc", margin: 0, paddingLeft: 20 }}>
          {Array.isArray(course.Counts) && course.Counts.length > 0 ?course.Counts.map((item) => (
            <li
              key={item.TaskStatus}
              style={{
                color: TaskStatusColors[item.TaskStatus],
                fontWeight: 500,
                marginBottom: 4,
              }}
            >
              {TaskStatusLabelsTr[item.TaskStatus]} ({item.Count})
            </li>
          )):null}
        </ul>
      </div>
    </div>}
  </div>

{/* --- Bottom Row: Buttons --- */}
<div
  className="card-buttons"
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    gap: 12,
    marginTop: 10,
    flexWrap: "wrap",
  }}
>
  <button
    onClick={() => {
      if (openCourseId === course.Id) {
        setOpenCourseId(null);
      } else {
        setOpenCourseId(course.Id);
        if (!topicsByCourse[course.Id]) {
          getSelectedSegmentCourseTopis(course.Id);
        }
      }
    }}
    style={{
      flex: "1 1 45%",
      maxWidth: 160,
      minWidth: 120,
      padding: "10px 0",
      backgroundColor: "#2563eb",
      color: "#fff",
      border: "none",
      borderRadius: 8,
      fontWeight: 600,
      cursor: "pointer",
      transition: "transform 0.1s ease, opacity 0.2s ease",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    Konu Seç
  </button>

  <button
    onClick={() =>
      history.push({
        pathname: "/NewQuestionApproveQuestionPage",
        state: {
          courseId: course.Id,
          courseName: course.Name,
          classTypeId: selectedExamCategory,
          contentType: ContentType.Courses,
          segmentId: selectedClassTypeId,
          allSegmentData:allCourseData
        },
      })
    }
    style={{
      flex: "1 1 45%",
      maxWidth: 160,
      minWidth: 120,
      padding: "10px 0",
      backgroundColor: "#16a34a",
      color: "#fff",
      border: "none",
      borderRadius: 8,
      fontWeight: 600,
      cursor: "pointer",
      transition: "transform 0.1s ease, opacity 0.2s ease",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
  >
    Başla
  </button>
</div>

<style>
{`
  /* Responsive fix for desktop */
  @media (min-width: 768px) {
    .card-buttons button {
      flex: none !important;
      width: 150px !important;
    }
  }

  @media (max-width: 767px) {
    .card-buttons button {
      flex: 1 1 45% !important;
      width: 100% !important;
    }
  }
`}
</style>


  {/* Hover Tooltip Behavior */}
  <style>
    {`
      .stats-container:hover .stats-tooltip {
        visibility: visible !important;
        opacity: 1 !important;
      }
    `}
  </style>
</div>



    {/* Accordion */}
    {openCourseId === course.Id && (
      <div
        style={{
          backgroundColor: "#f9fafb",
          borderRadius: 8,
          marginTop: 5,
          padding: "12px 16px",
        }}
      >
        {!topicsByCourse[course.Id] ? (
          <div style={{ textAlign: "center", padding: 10 }}>
            Konular yükleniyor...
          </div>
        ) : (
          Object.entries(topicsByCourse[course.Id]).map(
            ([topicTitle, subtopics]) => (
              <div key={topicTitle} style={{ marginBottom: 12 }}>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 16,
                    marginBottom: 6,
                    color: "#1f2937",
                  }}
                >
                  {topicTitle}
                </div>

                <div
                  style={{
                    display: "flex",
                    flexWrap: "no-wrap",
                    flexDirection:"column",
                    gap: "8px",
                    marginLeft: 10,
                  }}
                >
                  {subtopics.map((sub) => (
                    <div
                      key={sub.Id}
                      style={{
                        backgroundColor: "#e5e7eb",
                        borderRadius: 6,
                        padding: "6px 10px",
                        cursor: "pointer",
                        transition: "background 0.2s",
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        justifyContent: "space-between",
                      }}
                      onClick={() =>
                        // console.log("states-history", {
                          // courseId: course.Id,
                          // courseName: course.Name,
                          // topicName: topicTitle,
                          // SegmentTopicId: sub.Id,
                          // subTopicName: sub.Name,
                          // // examType: course.ExamType,
                          // classTypeId: selectedExamCategory,
                        // },)
                        history.push({
                          pathname:
                            "/NewQuestionApproveQuestionPage",
                          state: {
                            courseId: course.Id,
                            courseName: course.Name,
                            topicName: topicTitle,
                            SegmentTopicId: sub.Id,
                            subTopicName: sub.Name,
                            // examType: course.ExamType,
                            classTypeId: selectedExamCategory,
                            contentType:ContentType.SubCourseTopic,
                            segmentId:selectedClassTypeId,
                            allSegmentData:allCourseData
                            

                          },
                        })
                      }
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#d1d5db")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "#e5e7eb")
                      }
                    >
                      <div style={{ fontWeight: 600, color: "#111827" }}>{sub.Name}</div>

{/* stats pill (same look & tooltip as cards) */}
{sub.TotalCount>0&& <div
      style={{
        backgroundColor: "#fff",
        borderRadius: 6,
        padding: "6px 12px",
        display: "flex",
        gap: 8,
        color: "#111",
        fontWeight: 600,
        position: "relative",
        cursor: "default",
      }}
      className="stats-container"
      onClick={(e) => e.stopPropagation()}
    >
      
      {Array.isArray(sub.Counts) && sub.Counts.length > 0 ?sub.Counts.map((item) => (
        <span
          key={item.TaskStatus}
          style={{
            color: TaskStatusColors[item.TaskStatus],
          }}
        >
          {item.Count}
        </span>
      )):null}

      {/* Tooltip */}
     <div
        style={{
          visibility: "hidden",
          opacity: 0,
          position: "absolute",
          top: "120%",
          right: 0,
          backgroundColor: "#fff",
          color: "#111",
          padding: "10px 14px",
          borderRadius: 8,
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          fontSize: 14,
          transition: "opacity 0.2s ease, visibility 0.2s ease",
          zIndex: 10,
          minWidth: 180,
        }}
        className="stats-tooltip"
      >
        <ul style={{ listStyleType: "disc", margin: 0, paddingLeft: 20 }}>
          {Array.isArray(sub.Counts) && sub.Counts.length > 0 ?sub.Counts.map((item) => (
            <li
              key={item.TaskStatus}
              style={{
                color: TaskStatusColors[item.TaskStatus],
                fontWeight: 500,
                marginBottom: 4,
              }}
            >
              {TaskStatusLabelsTr[item.TaskStatus]} ({item.Count})
            </li>
          )):null}
        </ul>
      </div>
    </div>}
                    </div>
                  ))}
                </div>
              </div>
            )
          )
        )}
      </div>
    )}
  </div>
))}


      </div>
    </>
  );
};

export default CoursePage;
